module.exports = __webpack_public_path__ + "static/media/infiniti-provider.c41d774b.svg";